<template>
  <details class="bg-white shadow rounded-md">
    <summary class="flex items-center p-6 cursor-pointer">
      <div class="flex flex-none w-16 h-16 border rounded">
        <Icon
          :type="icon"
          class="m-auto text-blue-500"
          size="10"
        />
      </div>
      <div class="pl-4">
        <strong class="text-lg">{{ label }}</strong>
        <p class="text-gray-700">{{ text }}</p>
      </div>
    </summary>
    <div class="p-6 pt-0 -mt-6">
      <form :action="action" @submit.prevent="submit" class="flex flex-wrap md:pl-20 -ml-4 -mt-4">
        <div class="flex-none pt-4 pl-4 w-64 max-w-full">
          <Field
            v-model="form.code"
            :placeholder="placeholder"
            :error="form.errors.code"
            :type="field"
          />
        </div>
        <div class="pt-4 pl-4">
          <button class="button" type="submit">
            Verifizieren
          </button>
        </div>
      </form>
    </div>
  </details>
</template>

<script>
import Field from 'Web/Form/Field.vue';
import Icon from 'Web/Shared/Icon.vue';
import { useForm } from '@inertiajs/inertia-vue3/dist';

export default {
  inheritAttrs: false,
  components: {
    Field,
    Icon,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      default: 'text',
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  setup(props) {
    const form = useForm({
      event: props.event.id,
      code: null,
    });

    function submit(event) {
      form.post(event.target.action, {
        preserveScroll: true,
      });
    }

    return {
      form,
      submit,
    }
  }
}
</script>
